module.exports = __webpack_public_path__ + "img/code_53656D70726F6E697573.23f31f43.svg";